import React, { useEffect, useState } from "react";
import { PDFViewer, PDFDownloadLink } from "@react-pdf/renderer";
import { useLocation, useNavigate } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import TimeSheetSummaryReportDocument from "./TimeSheetSummaryDocument";


const TimeSheetSummaryReportPreview = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [timeSheetSummaryReportPrintData, setTimeSheetSummaryReportPrintData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (location.state) {
      setTimeSheetSummaryReportPrintData(location.state.timeSheetSummaryReportPrintData);
      setLoading(false);
    }
  }, [location]);

  console.log("timeSheetSummaryReportPrintData:", timeSheetSummaryReportPrintData);

  const onBack = () => {
    navigate("/admin/timeSheetSummaryReport");
  };

  return (
    <div className="mb-4 mx-4 ">
      <div className="flex justify-between items-center mb-4">
        {/* <h2 className="text-xl font-normal my-4">Timesheet Summary Print</h2> */}
        <div className="flex justify-left items-center ">
              <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
              <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
                {/* <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-gradient-to-br from-[#2663EB] to-blue-700 text-white shadow-lg">
      <MdPersonAddAlt className="w-7 h-7" />
      </span> */}
                <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
                  TIMESHEET SUMMARY PRINT
                </span>
              </h6>
            </div>

        <button
          onClick={onBack}
          className="flex items-center gap-2 bg-gray-700 hover:bg-gray-800 
                            text-white px-4 py-2 rounded-lg 
                            transition-all duration-200 
                            shadow-sm hover:shadow-md"
        >
          <IoArrowBack className="text-lg" />
          Back
        </button>
      </div>

      <div className="flex flex-col items-center h-screen">
        {loading ? (
          <div className="text-center text-gray-500 mt-10">
            Loading Data...
          </div>
        ) : !timeSheetSummaryReportPrintData || timeSheetSummaryReportPrintData.length === 0 ? (
          <div className="text-center text-gray-500 mt-10">
            No TimeSheetSummary Report Available!
          </div>
        ) : (
          <>
            <div className="w-full h-screen border border-gray-300 mb-4">
              <PDFViewer width="100%" height="100%">
                <TimeSheetSummaryReportDocument timeSheetReportPrintData={timeSheetSummaryReportPrintData} />
              </PDFViewer>
            </div>

            <div className="mt-2 mb-6">
              <PDFDownloadLink
                document={
                  <TimeSheetSummaryReportDocument timeSheetReportPrintData={timeSheetSummaryReportPrintData} />
                }
                fileName={`Timesheet_Summary || "print"}.pdf`}
                className="bg-blue-500 text-white px-4 py-2 rounded"
              >
                {({ loading }) =>
                  loading
                    ? "Preparing PDF..."
                    : "Download Timesheet Report"
                }
              </PDFDownloadLink>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default TimeSheetSummaryReportPreview;
